<template>
  <CountrySwitchRedirectionBanner
    v-if="bannerConfig"
    ref="bannerRef"
    :buttonLabel="bannerConfig.buttonLabel"
    data-test="country-switch-redirection-banner"
    :handleClose="bannerConfig.handleClose"
    :handleRedirection="bannerConfig.handleRedirection"
    :message="bannerConfig.message"
    :trackingName="bannerConfig.trackingName"
    :trackingZone="bannerConfig.trackingZone"
  />
</template>

<script setup lang="ts">
import { computed, toRef } from 'vue'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { useCountrySwitchRedirection } from '~/scopes/navigation/composables/useCountrySwitchRedirection'
import { useLocaleSwitchBanner } from '~/scopes/navigation/composables/useLocaleSwitchBanner'

import translations from './CountrySwitch.translations'
import CountrySwitchRedirectionBanner from './CountrySwitchRedirectionBanner.vue'

const i18n = useI18n()

const { user } = useUserStore()
const detectedCountryCode = computed(() => user.value.detectedCountryCode)

const {
  isRedirectionSuggested,
  handleClose: countrySwitchHandleClose,
  handleRedirection: countrySwitchHandleRedirection,
  linkToDetectedMarket,
} = useCountrySwitchRedirection(toRef(detectedCountryCode))

const {
  isLocaleSwitchSuggested,
  suggestedLocale,
  linkToSuggestedLocale,
  handleClose: localeSwitchHandleClose,
  handleSwitch: localeSwitchHandleSwitch,
} = useLocaleSwitchBanner()

const bannerConfig = computed(() => {
  if (
    !isRedirectionSuggested.value &&
    isLocaleSwitchSuggested.value &&
    suggestedLocale.value &&
    linkToSuggestedLocale.value
  ) {
    return {
      message: i18n(translations.spanishBannerText),
      buttonLabel: i18n(translations.spanishBannerCta),
      trackingName: 'prompt_locale_switch',
      trackingZone: 'banner_locale_switch',
      handleClose: localeSwitchHandleClose,
      handleRedirection: localeSwitchHandleSwitch,
    }
  }

  if (
    isRedirectionSuggested.value &&
    detectedCountryCode.value &&
    linkToDetectedMarket.value
  ) {
    return {
      message: i18n(translations.redirectionBannerLabel, {
        marketPlace: i18n.country(detectedCountryCode.value),
      }),
      buttonLabel: i18n(translations.redirectionBannerUpdateButton),
      trackingName: 'prompt_country_switch',
      trackingZone: 'banner_country_switch',
      handleClose: countrySwitchHandleClose,
      handleRedirection: countrySwitchHandleRedirection,
    }
  }

  return null
})
</script>
